document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("optional-modules-tabs")) {
        import(/* webpackChunkName: "optional-modules" */ "/Features/OptionalModules/js/optional-modules.js").then((module) => {
            new module.default();
        });
    }
});
